import React from 'react';
// import { } from 'framer-';
import { Link } from 'react-router-dom';
import './AdminStyles.scss';

const AdminPageHeader = ({ title, subtitle, breadcrumbs, actionButton, children }) => {

    return (
        <div className="admin-page-header">
            <div className="admin-header-main">
                <div className="admin-header-text">
                    {breadcrumbs && (
                        <div className="admin-breadcrumbs">
                            <Link to="/console/dashboard" className="breadcrumb-link">Dashboard</Link>
                            <span className="breadcrumb-separator">/</span>
                            <span className="breadcrumb-current">{breadcrumbs}</span>
                        </div>
                    )}
                    <h1>{title}</h1>
                    {subtitle && <p className="admin-subtitle">{subtitle}</p>}
                </div>
                {actionButton && (
                    <div className="admin-header-actions">
                        {actionButton}
                    </div>
                )}
            </div>

            {children && (
                <div className="admin-header-controls">
                    {children}
                </div>
            )}
        </div>
    );
};

export default AdminPageHeader;
